import {
  getDatasetOrderedByWeekAndYear,
  getDataset,
} from "api/dataVisualisation/client";
import { DataDownloadFormat } from "models/dataDownload/dataDownloadFormat";
import { DataDownloadModel } from "models/dataDownload/dataDownloadModel";
import { GenerationForecastDownloadDataModel } from "models/generationForecast/generationForecastDownloadModels/generationForecastDownloadDataModel";

export const getGenerationForecast14DayNOUDownloadData = async (
  format: DataDownloadFormat
): Promise<DataDownloadModel<GenerationForecastDownloadDataModel>> =>
  getDataset<GenerationForecastDownloadDataModel>(format, "NOU2T14D");

export const getGenerationForecast3YearNOUDownloadData = async (
  format: DataDownloadFormat
): Promise<DataDownloadModel<GenerationForecastDownloadDataModel>> =>
  getDatasetOrderedByWeekAndYear<GenerationForecastDownloadDataModel>(
    format,
    "NOU2T3YW"
  );
